import TrialBalance from '../pages/MDExpensesReport/MDExpensesReport';

const mdExpensesReportRoute = {
  public: [],
  auth: [
    {
      name: 'md_expense_report',
      path: '/finance-and-accounting/md-expense-report',
      component: TrialBalance,
    },
  ],
};

export default mdExpensesReportRoute;
